import { render, staticRenderFns } from "./ImpersonationBanner.vue?vue&type=template&id=15e236cb&scoped=true"
import script from "./ImpersonationBanner.vue?vue&type=script&lang=ts"
export * from "./ImpersonationBanner.vue?vue&type=script&lang=ts"
import style0 from "./ImpersonationBanner.vue?vue&type=style&index=0&id=15e236cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e236cb",
  null
  
)

export default component.exports